var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    {
      staticStyle: { "flex-wrap": "nowrap" },
      attrs: { row: "", "justify-end": "" }
    },
    [
      _vm.userCanRevoke
        ? _c(
            "v-btn",
            {
              staticClass: "ma-0 mr-2",
              class: { "edit-delete-button": _vm.visibilityHover },
              attrs: { "x-small": "", icon: "", text: "", color: "accent" },
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  return _vm.$emit("revoke")
                }
              }
            },
            [_c("v-icon", [_vm._v("mdi-lock-open")])],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isFloorbox && _vm.hasClosure
        ? _c(
            "v-btn",
            {
              staticClass: "ma-0 mr-2",
              class: { "edit-delete-button": _vm.visibilityHover },
              attrs: { "x-small": "", icon: "", text: "", color: "accent" },
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  return _vm.$emit("open-floorbox")
                }
              }
            },
            [_c("v-icon", [_vm._v("mdi-open-in-app")])],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.userCanWorkspace
        ? _c(
            "v-btn",
            {
              staticClass: "ma-0 mr-2",
              class: { "edit-delete-button": _vm.visibilityHover },
              attrs: { "x-small": "", icon: "", text: "", color: "accent" },
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  return _vm.$emit("workspace")
                }
              }
            },
            [_c("v-icon", [_vm._v("mdi-vector-arrange-below")])],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.userCanOpen
        ? _c(
            "v-btn",
            {
              staticClass: "ma-0 mr-2",
              class: { "edit-delete-button": _vm.visibilityHover },
              attrs: { "x-small": "", icon: "", text: "", color: "accent" },
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  return _vm.$emit("open")
                }
              }
            },
            [_c("v-icon", [_vm._v("filter_none")])],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.userCanEdit
        ? _c(
            "v-btn",
            {
              staticClass: "ma-0 mr-2",
              class: { "edit-delete-button": _vm.visibilityHover },
              attrs: { "x-small": "", icon: "", text: "", color: "accent" },
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  return _vm.$emit("edit")
                }
              }
            },
            [_c("v-icon", [_vm._v("edit")])],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.userCanDelete
        ? _c(
            "v-btn",
            {
              staticClass: "ma-0",
              class: { "edit-delete-button": _vm.visibilityHover },
              attrs: { "x-small": "", icon: "", text: "", color: "accent" },
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  return _vm.$emit("delete")
                }
              }
            },
            [_c("v-icon", [_vm._v("delete")])],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-67bdae97", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67bdae97","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_Molecules/AppDatatableActionButtons.vue
// module id = null
// module chunks = 